const INITIAL_SWITCHES_STATE = {
  perseoGlobal: {
    cencopay: true,
    isGA4ListFeatureEnabled: true,
    isBilling3DsEnabled: true
  }
};

export const DEFAULT_DEV_STATE = {
  switches: INITIAL_SWITCHES_STATE
};
